import styleConfirmOtp from "./confirmOtp.module.css";
import logo from "../../../assets/img/logo-1.png";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import Footer from "../../../layouts/footer/Footer";
import {
  forgotPassowrdPhone,
  generateTokenForOtp,
  registerConfirmOTP,
  resetPassOtp,
} from "../../../adapters/apis/auth/auth";
import { set } from "date-fns";

function ConfirmOtpForget() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6 digits
  const [isLoading, setIsLoading] = useState(false);
  const inputsRef = useRef([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [timeLeft, setTimeLeft] = useState(0); // 5 minutes = 300 seconds
  const [resetOtp, setResetOtp] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  // setToken(location.state?.token ||          // best UX
  // localStorage.getItem("request_code") || // survives refresh
  // new URLSearchParams(window.location.search).get("token") || // deep link
  // "");
  const user_id = localStorage.getItem("user_id");
  const mobile = localStorage.getItem("mobile");
  let STORAGE_KEY = 0;
  let endTime = 0;
  let id = 0;
  let left = 0;

  const focusFirstInput = () => {
    const el = inputsRef.current?.[0];
    if (el && typeof el.focus === "function") {
      el.focus();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("mobile") == null) {
      navigate("/login");
    }
    // Wait a tick to ensure the input is in the DOM (StrictMode safe)
    const id = setTimeout(focusFirstInput, 0);
    return () => clearTimeout(id);
  }, []);

  //for refreshing page
  useEffect(() => {
    if (localStorage.getItem("mobile") == null) {
      navigate("/login");
    }
    if (token) localStorage.setItem("request_code", token);
  }, [token]);

  const formatCountdownMessage = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    if (minutes < 1) {
      return "تبقى دقيقة";
    } else if (minutes <= 2) {
      return "تبقى دقيقتان";
    } else if (minutes <= 3) {
      return `تبقى ثلاث دقائق`;
    } else if (minutes <= 4) {
      return `تبقى أربع دقائق`;
    } else if (minutes <= 5) {
      return `تبقى خمس دقائق`;
    }
    return "";
  };

  useEffect(() => {
    if (!token) return;
    STORAGE_KEY = `otp_end_time:${token}`;
    // 1) Read expiry if exists; otherwise set new expiry 5 minutes ahead
    let endTime = Number(localStorage.getItem(STORAGE_KEY));
    if (!endTime || Number.isNaN(endTime)) {
      endTime = Date.now() + 5 * 60 * 1000; // 5 minutes from now
      localStorage.setItem(STORAGE_KEY, String(endTime));
    }

    // 2) Initialize remaining
    const calcRemaining = () =>
      Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    setTimeLeft(calcRemaining());

    // 3) Tick every second
    id = setInterval(() => {
      left = calcRemaining();
      setTimeLeft(left);
      if (left <= 0) {
        clearInterval(id);
      }
    }, 1000);

    // 4) Cleanup on unmount or token change
    return () => clearInterval(id);
  }, [token, resetOtp]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  // Handle input change
  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // Only numbers

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // One digit
    setOtp(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  // Handle backspace: move to previous if empty
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault(); // Prevent default paste behavior

    const pastedText = e.clipboardData.getData("text").trim();

    // Check if it's exactly 6 digits
    if (/^\d{6}$/.test(pastedText)) {
      const digits = pastedText.split("");
      setOtp(digits); // Fill all inputs

      // Focus the last input after paste
      inputsRef.current[5]?.focus();
    }
  };

  const handleResend = () => {
    if (localStorage.getItem("mobile") == null) {
      navigate("/login");
    }
    setIsLoading(true);
    setErrorMsg("");
    setOtp(["", "", "", "", "", ""]);

    forgotPassowrdPhone({
      mobile: localStorage.getItem("mobile"),
      context: "forgot_password",
    })
      .then((res) => {
        if (res?.data?.responseCode == 429) {
          setErrorMsg(res?.data?.message);
          setIsLoading(false);
        } else {
          setResetOtp();
          navigate(
            `/confirm-otp-forget?token=${encodeURIComponent(res?.data?.data?.request_code)}&context=${encodeURIComponent(res?.data?.data?.context)}`,
          );
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setErrorMsg(error?.response?.data?.message);
        setIsLoading(false);
      })
      .finally(() => {});
  };

  const handleVerify = () => {
    if (localStorage.getItem("mobile") == null) {
      navigate("/login");
    }
    const code = otp.join("");

    if (code.length !== 6) {
      setErrorMsg("يجب ادخال رمز التحقق OTP");
      return;
    }
    setIsLoading(true);
    setErrorMsg("");
    resetPassOtp({
      token: localStorage.getItem("request_code"),
      otp: code,
      mobile: localStorage.getItem("mobile"),
      user_id: localStorage.getItem("user_id"),
      context: localStorage.getItem("context"),
    })
      .then((res) => {
        if (res?.data?.responseCode == 422) {
          setErrorMsg(res?.data?.message);
          setIsLoading(false);
        } else if (res?.data?.responseCode == 200) {
          setErrorMsg("");
          generateTokenForOtp({
            mobile: localStorage.getItem("mobile"),
          })
            .then((res) => {
              navigate(
                `/new-password?token=${res?.data?.reset_token}&mobile=${res?.data?.mobile}`,
              );
              setIsLoading(false);
            })
            .catch((error) => {
              setErrorMsg("حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى");
              setIsLoading(false);
            })
            .finally(() => {});
        }
      })
      .catch((error) => {
        setErrorMsg(error?.response?.data?.message);
        setIsLoading(false);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };

  if (!token) {
    return (
      <>
        <section className={styleConfirmOtp["otp-section"]}>
          <div className="container text-center mt-5">
            <h3 className="text-danger">
              لا يمكن الوصول إلى هذه الصفحة مباشرة
            </h3>
            <p>يرجى البدء من صفحة التسجيل</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => navigate("/register")}
            >
              العودة للتسجيل
            </button>
          </div>
        </section>
        <Footer />
      </>
    );
  }
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className={styleConfirmOtp["otp-section"]}>
          <div className="container mb-5">
            <div className={`card ${styleConfirmOtp["card"]}`}>
              <a href="/" className={styleConfirmOtp["logo-wrap"]}>
                <img src={logo} alt="Logo" />
              </a>

              <div className={`card-body ${styleConfirmOtp["card-body"]}`}>
                <h5
                  className={`${styleConfirmOtp["card-title"]} card-title fw-bold`}
                >
                  التحقق من الهوية
                </h5>
                <p className={styleConfirmOtp["subtitle"]}>
                  لقد تم بالفعل إرسال رمز التحقق OTP إلى رقم هاتفك المسجل، يرجى
                  التحقق من صندوق الرسائل الخاص بك
                </p>

                {/* OTP inputs */}
                <div
                  className={styleConfirmOtp["otp-inputs"]}
                  onPaste={handlePaste}
                  role="group"
                  aria-label="OTP inputs"
                >
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      ref={(el) => (inputsRef.current[index] = el)}
                      className={`${styleConfirmOtp["otp-input"]} ${
                        digit ? styleConfirmOtp["filled"] : ""
                      }`}
                      aria-label={`الرقم ${index + 1}`}
                    />
                  ))}
                </div>

                {/* Timer + Resend */}
                <div className={styleConfirmOtp["timer-row"]}>
                  {timeLeft > 0 && (
                    <>
                      <span className={styleConfirmOtp["time-left"]}>
                        {formatTime(timeLeft)}
                      </span>
                      <span className={styleConfirmOtp["time-left"]}>
                        {formatCountdownMessage(timeLeft)}
                      </span>
                    </>
                  )}
                  {errorMsg && (
                    <p
                      className="text-danger text-center mt-3 fw-bold"
                      dir="rtl"
                    >
                      {errorMsg}
                    </p>
                  )}
                </div>

                {/* ConfirmOtp */}
                <div className={styleConfirmOtp["actions"]}>
                  <button
                    type="button"
                    className={styleConfirmOtp["btn-verify"]}
                    disabled={isLoading}
                    onClick={handleVerify}
                  >
                    التحقق من رمز الOTP
                  </button>

                  <button
                    type="button"
                    className={styleConfirmOtp["resend-link"]}
                    onClick={handleResend}
                    disabled={isLoading}
                  >
                    إعادة إرسال رمز التحقق
                  </button>
                </div>
                {/* Navigation */}
                <div className={styleConfirmOtp["nav-button"]}>
                  <span
                    className="text ps-2"
                    style={{ cursor: "pointer", color: "#32A8ED" }}
                    onClick={() => {
                      navigate("/forget-password-phone");
                    }}
                  >
                    العودة إلى الشاشة السابقة
                  </span>
                  <i
                    style={{ color: "#32A8ED" }}
                    className="fa-solid fa-arrow-left mt-1"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}

export default ConfirmOtpForget;
